import { SurveyActivity } from './survey-activity';

export const SmsSurveyActivity = [SurveyActivity.SENT, SurveyActivity.CLICKED, SurveyActivity.FEEDBACK];
